var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9268 1.109C15.8052 0.86563 15.5618 0.726562 15.301 0.726562H0.698975C0.438224 0.726562 0.194856 0.883013 0.0731723 1.109C-0.0485116 1.35237 -0.0137448 1.6305 0.142706 1.8391L6.27905 9.55734V14.5811C6.27905 14.8419 6.41812 15.0679 6.6441 15.1896C6.7484 15.2417 6.8527 15.2765 6.97439 15.2765C7.11346 15.2765 7.25252 15.2417 7.37421 15.1548L9.30377 13.8163C9.5819 13.6077 9.73835 13.2948 9.73835 12.9645V9.53995L15.8573 1.8391C16.0138 1.6305 16.0485 1.35237 15.9268 1.109Z",
    fill: "#656565"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.98bd6e0f.svg";
export { ForwardRef as ReactComponent };